module.exports = __webpack_public_path__ + "img/ext-link-arrow-dark.0cb4f251.svg";